import { connect } from 'react-redux';
import React, { useState, useEffect, Fragment } from 'react';
import styled from 'styled-components';

// Components and helper Components
import TicketList from '@components/individualPortal/ticket/TicketList';
import { FormattedMessage } from 'react-intl';
import { GIButton } from 'app-components';
import { useAppSelector } from '@hooks/index';
import { environmentSelector } from '@selectors/commonSelectors';

//Constants
import { dashboardModalTypes as MODALTYPES } from '@constants/individualPortal/dashboard/modals/dashboardModalTypes';
import { ALL_USER_ROLES } from '@constants/roles/userRoleTypes';
import { configs } from '@constants/configs/configs';

//Actions and functions
import { getTickets } from '@actions/individualPortal/ticket/ticketActionCreators';
import { showModal } from '@actions/common/actionCreators';
import { bindActionCreators } from 'redux';
import { dynamicSortOfObjects } from '@utils/tools/dynamicSortofObjects';

const StyledContainer = styled.div`
  .gi-button {
    ${props => props.hasMargin && 'margin-right: 40px !important;'}
  }
`;

const TicketListContainer = (props) => {
    const {
        environment,
        environment: {
            impersonation,
            impersonationDetails,
            ticketEnabled
        },
        actions: {
            getTickets,
            showModal
        },
    } = props;

    const userRole = environment.user.role === ALL_USER_ROLES.INDIVIDUAL;

    const [ ticketData, setTicketData ] = useState();
    const { isState } = useAppSelector(environmentSelector);

    useEffect( () => {
        if (ticketEnabled) {
            let  user_id = window.UID;
            if(impersonation){
                user_id = impersonationDetails.impersonatedUserId;
            }
            if(user_id===undefined){
                setTicketData(null);
                return;
            }
            getTickets(configs.endpoints.TICKETS.processReplacements({ id: user_id })).then(response => {
                const initialSort = dynamicSortOfObjects(response, 'creationTime', true, false, false);
                setTicketData(initialSort);
            });
        }
    }, []) ;


    const handleCreateTicketModal = () => {
        showModal({
            modalType: MODALTYPES.CREATE_TICKET_MODAL
        });
    };


    return (
        <Fragment>
            <StyledContainer className="ticket-header-styled text-left" hasMargin={isState.NM}>
                <h3 className="heading"><FormattedMessage id="ticket.table_title.header"/></h3>
                { impersonation && impersonationDetails.impersonatedUserId !== undefined ?
                    <GIButton className='submit-request-btn' id='submit_new_ticket_btn' type='button' labelId='ticket.table.button' onClickHandler={handleCreateTicketModal} />
                    : null }
                { !impersonation ?
                    <GIButton className='submit-request-btn' id='submit_new_ticket_btn' type='button' labelId='ticket.table.button' onClickHandler={handleCreateTicketModal} />
                    : null }
            </StyledContainer>
            { ticketData && ticketData.length ? <TicketList propsTicketListData={ticketData}  userRole={userRole}/>
                : null  }
        </Fragment>
    );
};


const mapStateToProps = state => ({
    environment: state.common.environment,
    ticketData: state.individualPortal.ticket


});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators( {
        showModal,
        getTickets
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(TicketListContainer);